import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Button from "../../../components/ui/Button";
import DatePicker from "react-datepicker"; // For time selection
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { host } from "../../../api/ApiCalls";
import { tostifyOption } from "../../../utils/toastOptions";
import { interests } from "../../../utils/interests";

const AddCourse = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [duration, setDuration] = useState("");
  const [totalSessions, setTotalSessions] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [availability, setAvailability] = useState([]);
  const [categories, setCategories] = useState([]);
  const [createCourseLoading, setCreateCourseLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(file); // ✅ Set image correctly

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
  };

  const handleAddAvailability = () => {
    setAvailability([...availability, { day: "", slots: [] }]);
  };

  const handleDayChange = (index, value) => {
    const updatedAvailability = [...availability];
    updatedAvailability[index].day = value;
    setAvailability(updatedAvailability);
  };

  const handleAddSlot = (index) => {
    const updatedAvailability = [...availability];
    updatedAvailability[index].slots.push({ startTime: null, endTime: null });
    setAvailability(updatedAvailability);
  };

  // const handleTimeChange = (index, slotIndex, field, time) => {
  //   if (!time) return; // Prevent invalid values

  //   const updatedAvailability = [...availability];
  //   updatedAvailability[index].slots[slotIndex][field] = time.toLocaleTimeString([], {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true, // AM/PM format
  //   });
  //   setAvailability(updatedAvailability);
  // };

  // const handleTimeChange = (index, slotIndex, field, time) => {
  //   if (!time) return;

  //   const updatedAvailability = [...availability];
  //   updatedAvailability[index].slots[slotIndex][field] =
  //     time.toLocaleTimeString([], {
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       hour12: true,
  //     });

  //   // ✅ Agar startTime & endTime dono set hain to split karna hai
  //   const startTime = updatedAvailability[index].slots[slotIndex].startTime;
  //   const endTime = updatedAvailability[index].slots[slotIndex].endTime;

  //   if (startTime && endTime) {
  //     const dividedSlots = splitTimeSlots(startTime, endTime);
  //     updatedAvailability[index].slots = dividedSlots; // Purane slots ki jagah naye add kar do
  //   }

  //   setAvailability(updatedAvailability);
  // };

  const handleTimeChange = (index, slotIndex, field, time) => {
    if (!time) return;

    const updatedAvailability = [...availability];
    updatedAvailability[index].slots[slotIndex][field] =
      time.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

    const startTime = updatedAvailability[index].slots[slotIndex].startTime;
    const endTime = updatedAvailability[index].slots[slotIndex].endTime;

    // ✅ Only split when both times are valid
    if (startTime && endTime) {
      try {
        const dividedSlots = splitTimeSlots(startTime, endTime);
        if (dividedSlots.length > 0) {
          updatedAvailability[index].slots = dividedSlots;
        }
      } catch (err) {
        console.error("Time slot splitting error:", err);
      }
    }

    setAvailability(updatedAvailability);
  };

  // ✅ Yeh function time ko "Total Sessions" ya duration ke mutabiq split karega
  const splitTimeSlots = (startTime, endTime) => {
    const start = parseTime(startTime);
    const end = parseTime(endTime);

    // ✅ Check if totalSessions and duration are provided
    if (!totalSessions || !duration) {
      alert("Please enter both total sessions and duration first.");
      return [];
    }

    // ✅ Total available time in minutes
    const totalMinutes = (end - start) / (1000 * 60);

    // ✅ Exact duration per session (in minutes)
    const durationPerSession = (duration / totalSessions) * 60;

    // ✅ Calculate possible sessions based on time range
    const possibleSessions = Math.floor(totalMinutes / durationPerSession);

    let slots = [];

    for (let i = 0; i < possibleSessions; i++) {
      // 🔹 Loop adjusted
      let sessionStart = new Date(
        start.getTime() + i * durationPerSession * 60 * 1000
      );
      let sessionEnd = new Date(
        sessionStart.getTime() + durationPerSession * 60 * 1000
      );

      slots.push({
        startTime: formatTime(sessionStart),
        endTime: formatTime(sessionEnd),
      });
    }

    return slots;
  };

  // ✅ Format Date to AM/PM Time String
  const formatTime = (date) => {
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // const parseTime = (time) => {
  //   console.log("Parsing time:", time);
  //   if (!time) return null;
  //   const [hour, minute, period] = time.match(/(\d+):(\d+) (AM|PM)/).slice(1);
  //   let hours = parseInt(hour, 10);
  //   const minutes = parseInt(minute, 10);
  //   if (period === "PM" && hours !== 12) hours += 12;
  //   if (period === "AM" && hours === 12) hours = 0;
  //   return new Date(1970, 0, 1, hours, minutes);
  // };

  const parseTime = (time) => {
    if (!time) return null;

    const match = time.match(/(\d+):(\d+) (AM|PM)/i); // 'i' = case-insensitive
    console.log("Parsing time:", time, "Match:", match);
    if (!match) return null;

    const [hour, minute, rawPeriod] = match.slice(1);
    let hours = parseInt(hour, 10);
    const minutes = parseInt(minute, 10);
    const period = rawPeriod.toUpperCase(); // ✅ Normalize casing

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return new Date(1970, 0, 1, hours, minutes);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCreateCourseLoading(true);

    if (!image) {
      console.error("❌ Image is missing!");
      toast.error("Image is missing!", tostifyOption);
      setCreateCourseLoading(false);
      return;
    }

    const token = localStorage.getItem("auth")
      ? JSON.parse(localStorage.getItem("auth")).token
      : null;

    if (!token) {
      alert("Authentication failed. Please log in again.");
      setCreateCourseLoading(false);
      return;
    }

    try {
      // Upload image
      const formDataImage = new FormData();
      formDataImage.append("image", image);

      const imageUploadRes = await axios.post(
        `${host}/api/upload/upload`,
        formDataImage,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      // Prepare course data
      const requestData = {
        title,
        description,
        price,
        duration,
        totalSessions,
        image: imageUploadRes.data.url,
        categories,
        availability,
      };

      // Create course
      const response = await axios.post(
        `${host}/api/courses/create`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Show success message
      toast.success("Course created successfully!");

      // Send course email
      await axios.post(
        `${host}/api/courses/send-course-email`,
        {
          course: {
            title,
            description,
            schedule: availability,
            price,
          },
          email: JSON.parse(localStorage.getItem("auth")).user.email,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Redirect to dashboard
      navigate("/dashboard");
      setCreateCourseLoading(false);
    } catch (error) {
      console.error("❌ Error creating course:", error.response?.data || error);
      toast.error(error.response?.data?.message || "Error creating course");
      setCreateCourseLoading(false);
    }
  };

  const toggleCategory = (category) => {
    if (categories.includes(category)) {
      setCategories(categories.filter((i) => i !== category));
    } else if (categories.length < 3) {
      setCategories([...categories, category]);
    } else {
      toast.error("You can select up to 3 categories only.", tostifyOption);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-8 bg-white shadow-lg rounded-xl">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        Create New Course
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Image Upload & Preview */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Course Image
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
            required
          />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              className="mt-3 w-96 rounded-md object-cover justify-center mx-auto"
            />
          )}
        </div>

        {/* Title */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Course Title
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
            required
            pattern="^[a-zA-Z0-9_ ]*$"
            title="Only letters, numbers, underscores and spaces are allowed"
            minLength={10}
            maxLength={50}
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
            required
            minLength={10}
            maxLength={500}
          ></textarea>
        </div>

        {/* Price */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Price ($)
          </label>
          <input
            type="number"
            value={price}
            // onChange={(e) => setPrice(e.target.value)}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              if (!isNaN(val)) {
                setPrice(Math.max(val, 1)); // Force value >= 1
              } else {
                setPrice("");
              }
            }}
            className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
            required
            min={1}
            step={1}
          />
        </div>

        {/* Duration */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Duration (in hours)
          </label>
          <input
            type="number"
            value={duration}
            // onChange={(e) => setDuration(e.target.value)}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              if (!isNaN(val)) {
                setDuration(Math.max(val, 1)); // Force value >= 1
              } else {
                setDuration("");
              }
            }}
            className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
            required
            min={1}
            step={1}
          />
        </div>

        {/* Total Sessions */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Total Sessions
          </label>
          <input
            type="number"
            value={totalSessions}
            // onChange={(e) => setTotalSessions(e.target.value)}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              if (!isNaN(val)) {
                setTotalSessions(Math.max(val, 1)); // Force value >= 1
              } else {
                setTotalSessions("");
              }
            }}
            className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
            required
            min={1}
            step={1}
          />
        </div>
        {/* Categories */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Categories (Select up to 3)
          </label>
          <div className="flex flex-wrap gap-2">
            {interests.map((cat) => (
              <button
                type="button"
                key={cat}
                className={`px-3 py-1 rounded-full text-sm border ${
                  categories.includes(cat)
                    ? "bg-indigo-600 text-white border-indigo-600"
                    : "bg-gray-100 text-gray-700 border-gray-300"
                }`}
                onClick={() => toggleCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
          {categories.length > 0 && (
            <div className="mt-2 text-xs text-gray-500">
              Selected: {categories.join(", ")}
            </div>
          )}
        </div>

        {/* Availability Section */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Availability
          </label>
          {availability.map((slot, index) => (
            <div key={index} className="mt-3 p-3 border rounded-md">
              {/* Weekday Selection */}
              <select
                value={slot.day}
                onChange={(e) => handleDayChange(index, e.target.value)}
                className="p-2 border rounded-md"
                required
              >
                <option value="">Select Day</option>
                {[
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ].map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>

              {/* Time Slots */}
              {slot.slots.map((timeSlot, slotIndex) => (
                <div key={slotIndex} className="mt-2 flex space-x-2 mb-2">
                  <DatePicker
                    selected={parseTime(timeSlot.startTime)}
                    onChange={(date) =>
                      handleTimeChange(index, slotIndex, "startTime", date)
                    }
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    dateFormat="h:mm aa"
                    placeholderText="Start Time"
                    required
                  />
                  <DatePicker
                    selected={parseTime(timeSlot.endTime)}
                    onChange={(date) =>
                      handleTimeChange(index, slotIndex, "endTime", date)
                    }
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    dateFormat="h:mm aa"
                    placeholderText="End Time"
                    required
                  />
                </div>
              ))}
              <button type="button" onClick={() => handleAddSlot(index)}>
                + Add Time Slot
              </button>
            </div>
          ))}
          <button
            type="button"
            className="mt-2"
            onClick={handleAddAvailability}
          >
            + Add Day
          </button>
        </div>

        <Button type="submit" disabled={createCourseLoading}>
          {createCourseLoading ? (
            <div className="flex items-center justify-center gap-2">
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                />
              </svg>
              Creating...
            </div>
          ) : (
            "Create Course"
          )}
        </Button>
      </form>
    </div>
  );
};

export default AddCourse;
